import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../common/Header";
import $ from "jquery";
import useAuth from "../../../hooks/useAuth";
import Toastify from "../../common/Toastify";
import { GETREQUEST, POSTREQUEST } from "../../helpers/ServiceRequest";
import { addTrailingZeros, formatPrice } from "../../helpers/common";

function InsertContainer() {
  const [containerCode, setContainerCode] = useState("");
  const [containerCodeErr, setContainerCodeErr] = useState("");
  const [containerDesc, setContainerDesc] = useState("");
  const [containerDescErr, setContainerDescErr] = useState("");
  const [containerValue, setContainerValue] = useState("");
  const [containerValueErr, setContainerValueErr] = useState("");
  const [returnValue, setReturnValue] = useState("");
  const [returnValueErr, setReturnValueErr] = useState("");
  const [typeInCode, setTypeInCode] = useState("");
  const [current, setCurrent] = useState(1);
  const [CSID, setCSID] = useState("");
  const [CSIDErr, setCSIDErr] = useState("");
  const [crateSuppliers, setCrateSuppliers] = useState([]);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const { user } = useAuth();
  useEffect(() => {
    const fetchData = async () => {
      let URL = process.env.REACT_APP_API_URL + "/get-all-crate-suppliers-list";
      let response = await GETREQUEST(URL, user.jwtToken);
      if (response?.data) {
        setCrateSuppliers(response.data);
      }
    }
    fetchData();
  }, []);
  let navigate = useNavigate();

  const addContainer = async (e) => {
    e.preventDefault();

    // Validate input fields
    const validateFields = () => {
      const fields = [
        { value: containerCode, setError: setContainerCodeErr },
        { value: containerDesc, setError: setContainerDescErr },
        { value: containerValue, setError: setContainerValueErr },
        { value: returnValue, setError: setReturnValueErr },
        { value: CSID, setError: setCSIDErr },
      ];

      let allValid = true;
      fields.forEach(field => {
        if (field.value === "") {
          field.setError(true);
          allValid = false;
        } else {
          field.setError(false);
        }
      });

      return allValid;
    };

    // Return if validation fails
    if (!validateFields()) {
      return false;
    }

    let URL = process.env.REACT_APP_API_URL + "/create-container";
    let payload = {
      ContainerCode: containerCode,
      ContainerDesc: containerDesc,
      ContainerValue: containerValue,
      ReturnValue: returnValue,
      TypeInCode: typeInCode,
      Current: parseInt(current),
      CSID,
    };
    let response = await POSTREQUEST(URL, payload, user.jwtToken);
    if (response?.data) {
      if (response.data.success) {
        setMessage(response.data.message);
        setMessageType('success');
        setTimeout(() => {
          navigate("/containers");
        }, 2000);
      } else {
        setMessage(response.data.message);
        setMessageType('error');
      }
    } else {
      setMessage(response?.error?.message || 'Failed to create Container !!');
      setMessageType('error');
    }
  };
  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  });
  return (
    <React.Fragment>
      <Header />
      {message && <Toastify message={message} type={messageType} />}
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-3 pb-4">
          <div className="table-elements">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item fs-15">
                  <Link
                    to="/containers"
                    className="text-decoration-none text-primary"
                  >
                    Containers
                  </Link>
                </li>
                <li
                  className="breadcrumb-item fs-15 active"
                  aria-current="page"
                >
                  Add New Container
                </li>
              </ol>
            </nav>
          </div>
          <div className="row justify-content-center">
            <div className="width-xxl-35 width-xl-44 width-lg-60 width-md-80">
              <div className="card p-4">
                <div className="card-header bg-white border-bottom-0">
                  <h1 className="title-semibold fs-24 mb-1">Add Container</h1>
                  <p className="text-lite fs-15 mb-0">
                    Please enter details to add new container
                  </p>
                </div>
                <form onSubmit={addContainer}>
                  <div className="card-body">
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Container Code
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md " +
                            (containerCodeErr ? " is-invalid" : "")
                          }
                          placeholder="Enter Container Code"
                          onChange={(e) => {
                            setContainerCode(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Description
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md " +
                            (containerDescErr ? " is-invalid" : "")
                          }
                          placeholder="Enter description"
                          onChange={(e) => {
                            setContainerDesc(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Container value
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md " +
                            (containerValueErr ? " is-invalid" : "")
                          }
                          placeholder="Enter value"
                          value={containerValue}
                          onChange={(e) => {
                            setContainerValue(formatPrice(e.target.value));
                          }}
                          onBlur={(e) => {
                            setContainerValue(addTrailingZeros(e.target.value));
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Return value
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md " +
                            (returnValueErr ? " is-invalid" : "")
                          }
                          placeholder="Enter return value"
                          value={returnValue}
                          onChange={(e) => {
                            setReturnValue(formatPrice(e.target.value));
                          }}
                          onBlur={(e) => {
                            setReturnValue(addTrailingZeros(e.target.value));
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Type In code
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control input-md "
                          placeholder="Enter type code"
                          onChange={(e) => {
                            setTypeInCode(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Crate Suppliers
                      </label>
                      <div className="col">
                        <select
                          className={
                            "form-select input-md" +
                            (CSIDErr ? " is-invalid" : "")
                          }
                          aria-label="Default select example"
                          onChange={(e) => {
                            setCSID(e.target.value);
                          }}
                        >
                          <option value="">Select Crate Suppliers</option>
                          {crateSuppliers.map((cratesup, index) => {
                            return (
                              <option value={cratesup.CSID} key={index}>
                                {cratesup.CrateSupplier}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Status
                      </label>
                      <div className="col">
                        <select
                          className="form-select input-md "
                          aria-label="Default select example"
                          onChange={(e) => {
                            setCurrent(e.target.value);
                          }}
                        >
                          <option value={1}>Active</option>
                          <option value={0}>Inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="card-footer bg-white d-flex p-3 border-top-0">
                    <div className="d-grid w-100">
                      <button
                        type="submit"
                        className="btn btn-secondary btn-md text-white d-flex align-items-center justify-content-center px-4 fw-medium rounded-3 mx-1"
                      >
                        Add Container
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default InsertContainer;
